import script from "./ViewSensor.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSensor.vue?vue&type=script&setup=true&lang=js"

import "./ViewSensor.vue?vue&type=style&index=0&id=516f6034&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516f6034"]])

export default __exports__